import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';

import { translate } from '@vimeo/i18n-runtime';
import { Modal, Button } from '@vimeo/iris/components';
import { DismissX } from '@vimeo/iris/icons';
import { Header as H } from '@vimeo/iris/typography';

import { BreakPoints } from '../../libs/MediaQuery';
import LanguageForm from '../form/Settings/LanguageForm';
import { Locales } from '../setLanguage';
import { Modals } from './types';

interface Props {
  active?: boolean;
  activeSet: Dispatch<SetStateAction<Modals | null>>;
  locale: string;
  localeLabels?: string[];
  locales?: Locales[];
  token: string;
}

export function LanguageSelectModal({
  active,
  activeSet,
  locale,
  localeLabels = [],
  locales = [],
  token,
}: Props) {
  return (
    <Modal
      active={active}
      content={
        <ModalStyled>
          <Header>{translate('Choose a different language')}</Header>
          <Dismiss onClick={() => activeSet(null)} />
          <LanguageForm
            locale={locale}
            locales={locales}
            localeLabels={localeLabels}
            token={token}
          />
        </ModalStyled>
      }
    />
  );
}

const Header = styled(H).attrs({ size: '4' })`
  margin-bottom: 1rem;
`;

const ModalStyled = styled.div`
  background: ${({ theme }) => theme.content.background};
  padding: 1.5rem;
  border-radius: 0.25rem;
  min-width: 90vw;
  @media (width > ${BreakPoints.xmd}px) {
    min-width: 28rem;
  }
`;

const Dismiss = styled(Button).attrs({
  icon: <DismissX />,
  format: 'basic',
  variant: 'minimalTransparent',
})`
  cursor: pointer;
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
`;
